export default __webpack_public_path__ + "static/media/freeTrialBackground.ca8558d5.svg";